<script>
    export let mime = ''
    export let scale = 'medium'
    
    const get_icon = mime => {

        // remove any parameter information
        mime = mime.split(';')[0]

        const mapping = {
            // office formats
            'application/pdf': 'fa-file-pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'fa-file-excel',
            'application/vnd.ms-excel': 'fa-file-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'fa-file-word',
            'application/msword': 'fa-file-word',
            'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint',
            'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'fa-file-powerpoint',


            // zips
            'application/gzip': 'fa-file-archive',
            'application/x-gzip': 'fa-file-archive',
            'application/zip': 'fa-file-archive',
            'application/vnd.rar': 'fa-file-archive',

            // code
            'text/csv': 'fa-file-csv',
            'text/javascript': 'fa-file-code',
            'text/css': 'fa-file-code',
            'text/html': 'fa-file-code',
            'text/xml': 'fa-file-code',
            'application/xml': 'fa-file-code',

            // misc
            'application/octet-stream': 'fa-file'
        }

        const prefix_mapping = {
            'video': 'fa-file-video',
            'image': 'fa-file-image',
            'audio': 'fa-file-audio',
            'text':  'fa-file-alt',
            'font':  'fa-file-alt',
            'application': 'fa-file'
        }

        if (mime in mapping) {
            return mapping[mime]
        }

        const prefix = mime.split('/')[0]

        if (prefix in prefix_mapping) {
            return prefix_mapping[prefix]
        }

        return 'fa-file'
    }

    const get_fa_scale = scale => {
        if (scale === 'medium') {
            return 'fa-lg'
        } else if (scale === 'large') {
            return 'fa-2x'
        }

        return ''
    }
</script>

<style>
    .is-xlarge {
        font-size: 3em;
        width: 3em;
    }
</style>

<span class="icon {'is-' + scale}">
    <i class="fas {get_fa_scale(scale)} {get_icon(mime)}"></i>
</span>
